// `initialPage` is 1-based; page 1 (or anything invalid) needs no scrolling.
export function getPendingPage(initialPage?: number): number | null {
  return typeof initialPage === 'number' &&
    Number.isInteger(initialPage) &&
    initialPage > 1
    ? initialPage
    : null;
}

// Whether a 1-based page exists in a document of `numPages` pages — one past
// the end can't be scrolled to, so the viewer just stays at the top.
export function isPageInDocument(page: number, numPages: number): boolean {
  return page >= 1 && page <= numPages;
}
